module.exports = __webpack_public_path__ + "img/1.a9d7c512.jpg";